@if (storesLoading) {
<div class="as-fixed-loader">
  <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
  <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
    {{ loadingText }}...
  </mat-label>
</div>
}
<main>
  <div class="as-row as-justify-end">
    <mat-icon
      svgIcon="ic-close-green"
      class="as-pointer"
      mat-dialog-close
    ></mat-icon>
  </div>
  @switch (step) { @case (0) {
  <div class="as-welcome">
    <h1 class="as-font as-font-16">
      {{ 'HOME.INVITE.welcome' | translate }}
    </h1>
    <h2 class="as-font as-font-14">
      {{ 'HOME.INVITE.intro' | translate }}
    </h2>
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'HOME.INVITE.enter' | translate }}</mat-label>
      <input mask="00000" [formControl]="zipCodeForm" matInput type="text" />
    </mat-form-field>
    <div class="buttons">
      <button
        (click)="getStoresByCoords()"
        [disabled]="zipCodeForm.invalid"
        mat-flat-button
        color="accent"
      >
        {{ 'HOME.INVITE.begin' | translate }}
      </button>
      <p mat-dialog-close class="skip as-font-14 as-font-green as-pointer">
        {{ 'HOME.INVITE.skipt' | translate }}
      </p>
    </div>
  </div>
  } @case (1) {
  <div class="as-stores">
    <div class="as-available-stores-container">
      <br />
      <div class="container">
        <div class="cont">
          <p class="as-font as-font-16">
            <strong>{{ 'DELIVERY.branches' | translate }}</strong>
          </p>
          <mat-label class="as-font as-font-16">
            {{ 'HOME.INVITE.zipCode' | translate }} {{ zipCodeForm.value }}
          </mat-label>
        </div>
        <p
          (click)="goStep(0)"
          class="as-font as-font-16 as-font-green as-pointer as-font-semibold"
        >
          {{ 'DELIVERY.change' | translate }}
        </p>
      </div>
      @if (!storesLoading && nearStores.length > 0) {
      <mat-label class="as-roboto-slab as-font-18 as-font-bold">
        {{ 'HOME.INVITE.selectStore' | translate }}
      </mat-label>
      }
      <mat-dialog-content
        ><br />
        @if (storesLoading) {
        <div class="as-row as-justify-center as-spinner-green">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
        } @if (!storesLoading && nearStores.length > 0) {
        <div class="list-container">
          @for (store of nearStores; track store) {
          <div
            [class.as-selected]="store.name === tempAddressStore.displayName"
            class="as-store-tile"
            matRipple
            (click)="setDefaultAddress(store)"
          >
            <div class="as-column">
              <mat-label class="as-font-semibold as-font-14">
                {{ store.name }}
              </mat-label>
              <mat-label class="as-font-14"> {{ store.address }} </mat-label>
            </div>
            <div class="as-row as-align-center">
              <mat-icon svgIcon="ic-pin-red"></mat-icon>
              <mat-label class="as-font-14">
                {{
                  store.meters >= 1000
                    ? (store.meters / 1000 | number : '1.2-2')
                    : store.meters
                }}
                {{ store.meters >= 1000 ? 'km' : 'm' }}
              </mat-label>
            </div>
          </div>
          }
        </div>
        } @else {
        <p class="no-stores as-font-bold as-font as as-font-18">
          {{ 'HOME.INVITE.noStores' | translate }}
        </p>
        }
        <ng-template #noStores>
          <p class="no-stores as-font-bold as-font as as-font-18">
            {{ 'HOME.INVITE.noStores' | translate }}
          </p>
        </ng-template>
        <br />
      </mat-dialog-content>
      <mat-dialog-actions class="as-row as-justify-end as-align-center">
        <button
          [disabled]="tempAddressStore.store === 0"
          (click)="onSettingAddress()"
          mat-flat-button
          color="accent"
          class="as-continue-button"
        >
          <mat-label class="as-font-14 as-font-semibold as-font-white">
            {{ 'GENERAL.continue' | translate }}
          </mat-label>
        </button>
      </mat-dialog-actions>
    </div>
  </div>
  } }
</main>
